import styled from "styled-components";
import heroImg from "../../Assets/heroimg.webp";
import { Link } from "react-router-dom";

export const HeroContainer = styled.section`
  background-image: linear-gradient(
      to right bottom,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),
    url(${heroImg});
  width: 100%;
  height: 80vh;
  background-size: cover;
  background-position: center;
  object-fit: cover;
  background-repeat: no-repeat;
  display: grid;
  place-items: center;

  @media screen and (max-width: 768px) {
    height: 60vh;
  }
`;

export const HeroTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 1200px;
  padding: 8px 24px;

  @media screen and (max-width: 768px) {
    padding: 8px 24px;
  }
`;

export const HeroTagline = styled.p`
  color: #fff;
  font-size: 1.6rem;
  top: 16px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

export const HeroHeading = styled.h1`
  color: #fff;
  font-weight: 700;
  font-size: 7.2rem;
  letter-spacing: 5px;

  span {
    color: #3cc830;
  }

  @media screen and (max-width: 768px) {
    font-size: 3.6rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ShopBtn = styled(Link)`
  background-color: #fff;
  color: #3cc830;
  border: none;
  padding: 1.6rem 3.2rem;
  margin-left: 21px;
  font-size: 1.8rem;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: #005900;
  }

  @media screen and (max-width: 768px) {
    padding: 1.2rem 2.4rem;
    font-size: 1.4rem;
  }
`;

export const SignUpBtn = styled(ShopBtn)`
  background-color: #3cc830;
  color: #fff;

  &:hover {
    background-color: #005900;
    color: #3cc830;
  }

  @media screen and (max-width: 768px) {
    margin-top: 1rem;
  }
`;
